import React, { useEffect, useState } from "react";
import { InputOTP } from "antd-input-otp";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  resendVerifyPhone,
  verifyPhone,
} from "../../../../../redux/services/auth/authServices";
import { Typography, Button, Form, Space, Flex } from "antd";
import { colors } from "../../../../../constants/colors";
import styles from "./OtpVerificationPhone.module.scss";
import { routes } from "../../../../../constants";
import { baseRouteMaker } from "../../../../../constants/routeConsts";
const { Title } = Typography;

const OtpVerificationPhone = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [isloading, setIsLoading] = useState(false);
  const provider = useSelector((state) => state.auth.registerDetails);

  const [counter, setCounter] = useState(59);

  const formattedCounter =
    counter >= 0 ? `${counter < 10 ? "0" : ""}${counter}` : "00";

  useEffect(() => {
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  const validateOTP = (rule, value, callback) => {
    if (!value || value.length !== 6) {
      callback(t("Otp.otpErrorMessage"));
      callback();
    } else {
      callback();
    }
  };

  const onFinish = () => {
    form.validateFields().then((values) => {
      const { otp } = values;
      const convertedString = otp.join("");
      if (!otp || otp.includes(undefined) || otp.includes("")) {
        form.setFields([
          {
            name: t("Otp.otpText"),
            errors: [t("Otp.otpErrorMessage")],
          },
        ]);
      } else {
        let otpBody = {
          phone: provider.phone,
          code: convertedString,
        };
        dispatch(verifyPhone(otpBody, navigate, setLoading));
      }
    });
  };

  const handleResendOtp = () => {
    let resendBody = {
      phone: provider?.phone,
    };
    if (counter === 0) {
      form.resetFields(["otp"]);
      dispatch(resendVerifyPhone(resendBody, setIsLoading));
      setCounter(59);
    }
  };

  useEffect(() => {
    if (!provider?.phone) {
      navigate(baseRouteMaker(routes.SIGN_UP));
    }
  }, []);

  return (
    <>
      <Flex
        vertical
        gap="0.6rem"
        className={styles.otpVerificationPhoneContainer}
      >
        <Title level={1} style={{ color: colors.primaryColor }}>
          {t("Otp.phoneOtpTitle")}
        </Title>
        <Title level={4} type="secondary" style={{ margin: 0 }}>
          {t("Otp.subTitlePhone")}
        </Title>
        <Title level={4} style={{ margin: 0 }}>
          {provider?.phone
            ? `+${
                provider?.phone?.country_code
              } ${provider?.phone?.phone_number.slice(
                0,
                3
              )}****${provider?.phone?.phone_number.slice(7)}`
            : ""}
        </Title>

        <Form
          layout="vertical"
          onFinish={onFinish}
          autoComplete="off"
          requiredMark={false}
          form={form}
        >
          <Flex vertical gap="10rem">
            <div>
              <Form.Item name="otp" rules={[{ validator: validateOTP }]}>
                <InputOTP
                  autoFocus
                  inputType="numeric"
                  length={6}
                  inputClassName={styles.otpInputClassName}
                  wrapperClassName={styles.otpWrapperClassName}
                  disabled={provider?.phone ? false : true}
                />
              </Form.Item>

              {provider?.phone ? (
                <Space>
                  <Title level={5}>{` 00 : ${formattedCounter}`}</Title>
                  <Title
                    level={5}
                    type="success"
                    disabled={counter === 0 ? false : true}
                    loading={isloading}
                    underline={true}
                    style={{
                      cursor: "pointer",
                      pointerEvents: counter !== 0 ? "none" : "visible",
                    }}
                    onClick={handleResendOtp}
                  >
                    {t("Otp.resendText")}
                  </Title>
                </Space>
              ) : (
                ""
              )}
            </div>

            <Button
              type="primary"
              style={{ width: "100%" }}
              htmlType="submit"
              loading={loading}
              disabled={provider?.phone ? false : true}
            >
              {t("Otp.submit")}
            </Button>
          </Flex>
        </Form>
      </Flex>
    </>
  );
};

export default OtpVerificationPhone;
